// A member's initial in a color that's always the same for that person.
//
// Photo uploads are a bigger job (storage, moderation, cropping). This gets most
// of the personality for none of that: everyone becomes visually recognizable at
// a glance on the leaderboard and in results, and the color never changes on them
// because it's derived from their user id, not from list order.

const PALETTE = [
  "#ffd166", // gold
  "#4cc9f0", // cyan
  "#06d6a0", // green
  "#ef476f", // pink
  "#b892ff", // purple
  "#ff9f1c", // orange
  "#7ae582", // mint
  "#f15bb5", // magenta
];

function colorFor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export function Avatar({ id, name, size = 36 }: { id: string; name: string; size?: number }) {
  const initial = (name?.trim()?.[0] ?? "?").toUpperCase();
  return (
    <span
      className="avatar"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        minWidth: size,
        background: colorFor(id),
        color: "#12141a",
        fontSize: Math.round(size * 0.44),
      }}
    >
      {initial}
    </span>
  );
}
